'use strict';

// Import our module information.
import actions from './actions';
import mutations from './mutations';

// Prepare state.
const state = {
  assets: [],
  collections: [],
  userAssets: [],
  itemCount: 0,
  collectionCount: 0,
  orderCount: 0,
  socket: {}
};

// Return the module prepared for use.
export default {
  namespaced: true,
  state,
  actions,
  mutations
};
